import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

type MarketingFormatoPecaField = Pick<CissAutoCompleteProps, 'onChange' | 'multiple' | 'label' | 'value'>;

export function MarketingFormatoPecaField({ onChange, multiple = false, label = 'Formato', value }: MarketingFormatoPecaField) {
    return (
        <CissAutoComplete
            value={value}
            label={label}
            multiple={multiple}
            onChange={onChange}
            selectedStringTemplate="{dsPecaMarketingFormato}"
            optionStringTemplate="{dsPecaMarketingFormato}"
            isOptionEqualToValue={(option, fieldValue) => option?.idPecaMarketingFormato === fieldValue?.idPecaMarketingFormato}
            requestOptions={{
                url: '/gestao/pecamarketingformato',
                sort: [{ property: 'idPecaMarketingFormato', direction: 'ASC' }],
                columns: 'idPecaMarketingFormato,dsPecaMarketingFormato',
            }}
        />
    );
}
